import React from "react";
import { createDfpAdComponent } from "@quintype/components";
import get from "lodash/get";

const ViewPortSizeMapping920X90T1 = [
  { viewport: [1264, 0], sizes: [[970, 90]] },
  { viewport: [1264, 0], sizes: [[728, 90]] },
  { viewport: [876, 0], sizes: [[728, 90]] },
  { viewport: [876, 0], sizes: [[468, 60]] },
  { viewport: [320, 0], sizes: [[320, 100]] },
  { viewport: [320, 0], sizes: [[320, 50]] }
];

const ViewPortSizeMapping468x60B1 = [
  { viewport: [1264, 0], sizes: [[970, 250]] },
  { viewport: [1264, 0], sizes: [[970, 90]] },
  { viewport: [1264, 0], sizes: [[728, 90]] },
  { viewport: [876, 0], sizes: [[728, 90]] },
  { viewport: [876, 0], sizes: [[468, 60]] },
  { viewport: [300, 0], sizes: [[300, 250]] }
];

const ViewPortSizeMapping336x280R2 = [
  { viewport: [1264, 0], sizes: [[300, 250]] },
  { viewport: [876, 0], sizes: [[728, 90]] },
  { viewport: [876, 0], sizes: [[468, 60]] },
  { viewport: [300, 0], sizes: [[300, 250]] }
];

const ViewPortSizeMappingFloating970x90 = [
  { viewport: [1264, 0], sizes: [[970, 90]] },
  { viewport: [1264, 0], sizes: [[970, 66]] },
  { viewport: [1264, 0], sizes: [[728, 90]] },
  { viewport: [876, 0], sizes: [[728, 90]] },
  { viewport: [876, 0], sizes: [[468, 60]] },
  { viewport: [320, 0], sizes: [[320, 50]] },
  { viewport: [320, 0], sizes: [[360, 60]] }
];

const ViewPortSizeMappingInArticle300x250 = [
  { viewport: [1264, 0], sizes: [[970, 250]] },
  { viewport: [1264, 0], sizes: [[300, 250]] },
  { viewport: [876, 0], sizes: [[300, 250]] },
  { viewport: [300, 0], sizes: [[300, 250]] }
];

export const CONFIG = {
  // Header Ads:
  // English-site
  EnPalo_HP_970x90_T1: {
    adUnit: "EnPalo_HP_970x90_T1", // home page
    sizes: [
      [970, 90],
      [728, 90],
      [468, 60],
      [320, 100],
      [320, 50]
    ],
    viewPortSizeMapping: ViewPortSizeMapping920X90T1
  },
  EnPalo_ROS_728x90_T1: {
    adUnit: "EnPalo_ROS_728x90_T1", // listing page
    sizes: [
      [970, 90],
      [728, 90],
      [468, 60],
      [320, 100],
      [320, 50]
    ],
    viewPortSizeMapping: ViewPortSizeMapping920X90T1
  },
  // bangla site
  Home_728x90_T1: {
    adUnit: "Home_728x90_T1", // home page
    sizes: [
      [970, 90],
      [728, 90],
      [468, 60],
      [320, 100],
      [320, 50]
    ],
    viewPortSizeMapping: ViewPortSizeMapping920X90T1
  },
  News_728x90_T1: {
    adUnit: "News_728x90_T1", // listing page
    sizes: [
      [970, 90],
      [728, 90],
      [468, 60],
      [320, 100],
      [320, 50]
    ],
    viewPortSizeMapping: ViewPortSizeMapping920X90T1
  },
  // english-site home page ads
  EnPalo_HP_336x280_R1: {
    adUnit: "EnPalo_HP_336x280_R1",
    sizes: [[300, 250]]
  },
  EnPalo_HP_468x60_B1: {
    adUnit: "EnPalo_HP_468x60_B1",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [468, 60],
      [300, 250]
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1
  },
  EnPalo_HP_336x280_R2: {
    adUnit: "EnPalo_HP_336x280_R2",
    sizes: [
      [768, 90],
      [468, 60],
      [300, 250]
    ],
    viewPortSizeMapping: ViewPortSizeMapping336x280R2
  },
  EnPalo_HP_728x90_B2: {
    adUnit: "EnPalo_HP_728x90_B2",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [468, 60],
      [300, 250]
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1
  },
  EnPalo_HP_300x250_R3: {
    adUnit: "EnPalo_HP_300x250_R3",
    sizes: [[300, 250]]
  },
  EnPalo_HP_Floating_970x90: {
    adUnit: "EnPalo_HP_Floating_970x90",
    sizes: [
      [970, 90],
      [970, 66],
      [728, 90],
      [360, 60],
      [320, 50]
    ],
    viewPortSizeMapping: ViewPortSizeMappingFloating970x90
  },
  // bangla-site home page ads
  Home_336x280_R1: {
    adUnit: "Home_336x280_R1",
    sizes: [[300, 250]]
  },
  Home_468x60_B1: {
    adUnit: "Home_468x60_B1",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [468, 60],
      [300, 250]
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1
  },
  Home_336x280_R2: {
    adUnit: "Home_336x280_R2",
    sizes: [
      [768, 90],
      [468, 60],
      [300, 250]
    ],
    viewPortSizeMapping: ViewPortSizeMapping336x280R2
  },
  Home_728x90_B2: {
    adUnit: "Home_728x90_B2",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [468, 60],
      [300, 250]
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1
  },
  Home_336x280_R3: {
    adUnit: "Home_336x280_R3",
    sizes: [[300, 250]]
  },
  Mobile_HP_Anchor: {
    adUnit: "Mobile_HP_Anchor",
    sizes: [
      [970, 90],
      [970, 66],
      [728, 90],
      [360, 60],
      [320, 50]
    ],
    viewPortSizeMapping: ViewPortSizeMappingFloating970x90
  },
  // english-site inner pages
  EnPalo_ROS_336x280_R1: {
    adUnit: "EnPalo_ROS_336x280_R1",
    sizes: [[300, 250]]
  },
  EnPalo_ROS_300x250_R2: {
    adUnit: "EnPalo_ROS_300x250_R2",
    sizes: [[300, 250]]
  },
  EnPalo_ROS_336x280_R3: {
    adUnit: "EnPalo_ROS_336x280_R3",
    sizes: [[300, 250]]
  },
  EnPalo_ROS_728x90_B2: {
    adUnit: "EnPalo_ROS_728x90_B2",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [300, 250],
      [468, 60]
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1
  },
  EnPalo_InArticle_300x250: {
    adUnit: "EnPalo_InArticle_300x250",
    sizes: [
      [970, 250],
      [300, 250]
    ],
    viewPortSizeMapping: ViewPortSizeMappingInArticle300x250
  },
  EnPalo_InArticle2_300x250: {
    adUnit: "EnPalo_InArticle2_300x250",
    sizes: [
      [970, 250],
      [300, 250]
    ],
    viewPortSizeMapping: ViewPortSizeMappingInArticle300x250
  },
  EnPalo_Inner_Floating_970x90: {
    adUnit: "EnPalo_Inner_Floating_970x90",
    sizes: [
      [970, 90],
      [970, 66],
      [728, 90],
      [468, 60],
      [360, 60],
      [320, 50]
    ],
    viewPortSizeMapping: ViewPortSizeMappingFloating970x90
  },
  // bangla-site inner page
  News_336x280_R1: {
    adUnit: "News_336x280_R1",
    sizes: [[300, 250]]
  },
  News_336x280_R2: {
    adUnit: "News_336x280_R2",
    sizes: [[300, 250]]
  },
  News_336x280_R3: {
    adUnit: "News_336x280_R3",
    sizes: [[300, 250]]
  },
  News_728x90_B2: {
    adUnit: "News_728x90_B2",
    sizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [300, 250],
      [468, 60]
    ],
    viewPortSizeMapping: ViewPortSizeMapping468x60B1
  },
  News_InArticle_300x250: {
    adUnit: "News_InArticle_300x250",
    sizes: [
      [970, 250],
      [300, 250]
    ],
    viewPortSizeMapping: ViewPortSizeMappingInArticle300x250
  },
  News_InArticle2_300x250: {
    adUnit: "News_InArticle2_300x250",
    sizes: [
      [970, 250],
      [300, 250]
    ],
    viewPortSizeMapping: ViewPortSizeMappingInArticle300x250
  },
  Mobile_Article_Anchor: {
    adUnit: "Mobile_Article_Anchor",
    sizes: [
      [970, 90],
      [970, 66],
      [728, 90],
      [468, 60],
      [360, 60],
      [320, 50]
    ],
    viewPortSizeMapping: ViewPortSizeMappingFloating970x90
  }
};

const getStoryType = (state, pageType) => {
  if (pageType === "story-page") {
    return get(state, ["qt", "data", "story", ["story-template"]]) || "text-story";
  } else {
    return "NA";
  }
};

const getStorySectionName = (state, pageType) => {
  if (pageType === "story-page") {
    return get(state, ["qt", "data", "story", "sections", 0, "slug"]);
  } else if (pageType === "section-page") {
    return get(state, ["qt", "data", "section", "slug"]);
  }
  return "NA";
};

const getStoryId = (state, pageType) => {
  if (pageType === "story-page") {
    return get(state, ["qt", "data", "story", "id"]) || "NA";
  }
  return "NA";
};

const getCollectionSlug = (state, props) => {
  const pagetype = get(state, ["qt", "pageType"]);
  if (pagetype === "story-page") {
    return get(state, ["qt", "data", "story", "sections", 0, "name"]);
  }
  return get(props, ["collectionSlug"], "DefaultCollection");
};

const getLayoutName = (state, props) => {
  const pagetype = get(state, ["qt", "pageType"]);
  if (pagetype === "story-page") {
    return "NA";
  }
  return get(props, ["layoutName"], "DefaultLayout");
};

const DfpAdContent = createDfpAdComponent({
  defaultNetworkID: "85406138",
  config: CONFIG,
  targeting: function(state, ownProps) {
    const pageType = get(state, ["qt", "pageType"]);
    const params = {
      publisherId: get(state, ["qt", "config", "publisher-id"]) || "",
      publisherName: get(state, ["qt", "config", "publisher-name"]),
      pageType: pageType,
      environment: get(state, ["qt", "config", "publisher-attributes", "env"]),
      storyType: getStoryType(state, pageType),
      section: getStorySectionName(state),
      storyId: getStoryId(state),
      collectionSlug: getCollectionSlug(state, ownProps),
      layoutName: getLayoutName(state, ownProps)
    };

    return params;
  }
});

const DfpAd = props => {
  return (
    <div className="dfp-ad-unit">
      <DfpAdContent {...props} />
    </div>
  );
};

export default DfpAd;
